import { render, staticRenderFns } from "./AlermMailSetting.vue?vue&type=template&id=a30bf06e"
import script from "./AlermMailSetting.vue?vue&type=script&lang=js"
export * from "./AlermMailSetting.vue?vue&type=script&lang=js"
import style0 from "./AlermMailSetting.vue?vue&type=style&index=0&id=a30bf06e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports